module.exports = __webpack_public_path__ + "static/media/sf_700_gray.88e493e4c358aa3fa28823012ef1d789.png";